import { render, staticRenderFns } from "./add-member-interest.vue?vue&type=template&id=0b893f00&scoped=true&"
import script from "./add-member-interest.vue?vue&type=script&lang=js&"
export * from "./add-member-interest.vue?vue&type=script&lang=js&"
import style0 from "./add-member-interest.vue?vue&type=style&index=0&id=0b893f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b893f00",
  null
  
)

export default component.exports